import React, { Fragment } from 'react';
import {IMyCoupons} from "../interfaces";
import CartCoupon from "../../../../ui/svg/shopping-cart/coupon";
import DataHelper from "../DAL/data-service";
import MyCouponItemData from "./MyCouponItemData";
import MyCouponSkuData from "./MyCouponSkuData";

interface IMyCouponsItem {
    item: any
}
/**
 * MyCouponsItem
 */
const MyCouponsItem = (props:IMyCouponsItem) => {

    // let couponMainId = props.item[0];
    let couponsList = props.item[1];
    let couponFirst = props.item[1][0] as IMyCoupons;

    const startText = couponsList.length > 1? 'These coupons ' : 'This coupon ';
    const IsSupportsMultiText = couponFirst.isSupportsMulti?
        startText +'can be combined with other coupons in the same transaction.' :
        startText +'cannot be combined with other coupons in the same transaction.';
    const isPersonal = couponFirst.isPersonal;
    let couponsListGroup = DataHelper.GroupAndSortCouponsList(couponsList);
    //console.log('couponsListGroup: ',couponsListGroup)
    return (
        <li className="p-4 mt-2 bg-green-100 border border-green">
            <div className="flex flex-row justify-between items-center">
                <div className="">
                    <div className="flex items-center">
                        {couponFirst.marketingName && <div className="text-lg font-bold mr-2">{couponFirst.marketingName}</div>}
                        { isPersonal && <div className="px-2 py-1 bg-blue-200 text-white">Personal Coupon</div> }
                    </div>
                    <div className="mt-4">{IsSupportsMultiText}</div>
                    {couponFirst.tC_URL && <div className="mt-2"><a className="blue9-link underline" href={couponFirst.tC_URL}>Terms & Conditions Apply</a>.</div>}
                    {!couponFirst.tC_URL && <div className="mt-2">See terms & conditions in your email.</div>}
                    {
                        couponsListGroup.map((clg, i) => {
                            // let clMainID = clg[0];
                            let clList = clg[1];
                            let clFirst = clg[1][0] as IMyCoupons;
                            //console.log('clg: ',clg);
                            return (
                                <Fragment key={ i }>


                                    { clList.length > 0 &&
                                        <ul className="coupons-list mt-4">

                                            <MyCouponItemData key={i} itemData={clFirst} />
                                        </ul>
                                    }

                                    {
                                        couponsList.length > 0 && couponsList[0].skuName &&
                                        <ul className="sku-list mt-4">
                                            <li className="font-bold mb-1">Valid toward the following products:</li>
                                                {clList.map((k:any, i:number) =>
                                                <MyCouponSkuData key={i} itemData={k} />
                                                )}
                                        </ul>
                                    }
                                </Fragment>
                            )
                        })
                    }
                    {/*/!*{couponsList.length > 0 &&*!/*/}
                    {/*    <ul className="coupons-list mt-4">*/}

                    {/*        {*/}
                    {/*            couponsList.map((k:any, i:number) =>*/}
                    {/*                <MyCouponItemData key={i} itemData={k} />*/}
                    {/*            )}*/}
                    {/*    </ul>*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    couponsList.length > 0 && couponsList[0].skuName &&*/}
                    {/*    <ul className="sku-list mt-4">*/}
                    {/*        <li className="font-bold mb-1">Valid toward the following products:</li>*/}
                    {/*        {*/}
                    {/*        couponsList.map((k:any, i:number) =>*/}
                    {/*            <MyCouponSkuData key={i} itemData={k} />*/}
                    {/*        )}*/}
                    {/*    </ul>*/}
                    {/*/!*}*!/*/}
                    {couponFirst.ctA_TEXT && couponsList.length > 0 &&
                        <div className="mt-4"><a className="blue9-link underline" href={couponFirst.ctA_URL}>{couponFirst.ctA_TEXT}</a></div>}
                    {!couponFirst.ctA_TEXT &&  couponsList.length > 0 && couponsList[0].skuDurationText &&
                        <div className="mt-4">
                            Apply to a <a className="blue9-link underline" href="/subscriptions">new purchase</a> or an <a className="blue9-link underline" href="/account/apply-subscriptions-coupon">ongoing subscription</a>
                        </div>
                    }
                </div>
                <div className="w-48 hidden md:block"><CartCoupon width="80" /></div>
            </div>
        </li>

    )
};

export default  MyCouponsItem;